import React from 'react';

import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import MaxWidth from '@marvelapp/marvel-ui/max-width';

import assets from 'marketing-website/configs/pages/enterprise/assets';

import ExperienceCard from './ExperienceCard.js';

import styles from './style/experience.module.css';

export default function Experience() {
  return (
    <div className={styles.main}>
      <div className={styles.wrap}>
        <Spacing size="xl" type="padding" position="bottom">
          <MaxWidth value={800}>
            <Heading tag="h2" weight="bold" size="xxxxl" color="black">
              A customer experience you’ll love
            </Heading>
          </MaxWidth>
        </Spacing>

        <Grid columns={3} alignItems="stretch" size="l">
          <GridItem columnSpan={3} columnSpanL={1}>
            <ExperienceCard
              title="Your design partner now, and in the future"
              subtitle="We help you understand the business value of design and drive transformation from the inside out. Our close customer relationships help us shape the future of the product and tailor solutions for your needs."
              image={assets.design}
            />
          </GridItem>
          <GridItem columnSpan={3} columnSpanL={1}>
            <ExperienceCard
              title="Around the clock support from day one"
              subtitle="Our friendly Customer Support and Experience team is on hand from day one to help brilliant companies like yours get up and running with the answers, training and resources you need."
              image={assets.support}
            />
          </GridItem>
          <GridItem columnSpan={3} columnSpanL={1}>
            <ExperienceCard
              title="Scalable pricing that makes sense, no surprises"
              subtitle="Our product drops jaws, not our pricing. It doesn't matter if you're starting to grow your team or transforming your business, our pricing structure is fair and based on how your teams operate."
              image={assets.scalable}
            />
          </GridItem>
        </Grid>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/enterprise/Experience.js